<template>
  <div class="sitelist">
    <!--头部-->
    <GlobTopNav title="收货地址管理"></GlobTopNav>
    <!--地址-->
    <div class="van-content">
      <div class="nodata text-cent" v-if="nodata && datas == ''">
        <P class="imgbox">
          <img src="/static/images/nodataimg1.png" />
        </P>
        <p class="text">还没有添加地址~</p>
      </div>
      <div class="van-address-list">
        <div class="van-radio-group">
          <div class="van-cell-group van-hairline--top-bottom">
            <div
              style="margin-bottom: 10px"
              class="van-cell van-cell--clickable van-address-item"
              v-if="datas != ''"
              v-for="(items, index) in datas"
              :key="items.id"
            >
              <div class="van-cell__value van-cell__value--alone">
                <div class="van-radio">
                  <span class="van-radio__input">
                    <input type="radio" value="1" checked="checked" class="van-radio__control" />
                    <i class="van-icon van-icon-checked"></i>
                  </span>
                  <span class="van-radio__label">
                    <div class="van-address-item__name">
                      {{ items.name }} <span class="float-right">{{ items.mobile }}</span>
                    </div>
                    <div class="van-address-item__address">
                      {{ items.addressInfo }}{{ items.address }}
                    </div>
                  </span>
                </div>
              </div>
              <i class="van-icon van-icon-edit van-address-item__edit"> </i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="addSiteBtn">
      <!--<router-link to="/user/mysite/addsite"><van-button style="font-size: 16px" class="theme-bd theme-bg">添加收货地址</van-button></router-link>-->
      <van-button @click="addsites()" style="font-size: 16px" class="theme-bd theme-bg"
        >新增收货地址</van-button
      >
    </div>
  </div>
</template>

<script>
import TopNav from "@/components/topnav";
export default {
  name: "mysite",
  components: {
    TopNav
  },
  data() {
    return {
      datas: "",
      nodata: false,
      checked: "",
      length: 0,
      siteList: [
        {
          id: "",
          name: "",
          tel: "",
          address: ""
        }
      ]
    };
  },
  methods: {
    amendSite: function(item, index) {
      this.$router.push({
        path: "/user/mysite/amendsite",
        query: { id: item.id }
      });
    },
    goBack: function() {
      history.back(-1);
    },
    onClickRight() {
      this.$refs.TopNav.topnavPlay();
    },
    addsites: function() {
      this.$router.push({ path: "/user/mysite/addsite" });
      // if (this.length < 5) {
        
      // } else {
      //   this.$toast("最多保存5条收货信息");
      // }
    },
    removeSite: function(id, index) {
      var isUser = localStorage.getItem("BLHuser");
      var mallid = localStorage.getItem("mallid");
      this.$dialog
        .confirm({
          message: "确定要删除此收货地址吗？"
        })
        .then(() => {
          this.$api.post(
            "user/address/delete",
            { id_example: mallid, token_user: isUser, id_address: id },
            res => {
              if (res.data.code == "100") {
                this.datas.splice(index, 1);
              } else {
                if (res.data.message == "token验证失败") {
                  this.$dialog
                    .confirm({
                      title: "提示 ",
                      message: "您还未登录是否去登录？"
                    })
                    .then(() => {
                      this.$router.push({ name: "NoteLogin" });
                    })
                    .catch(() => {});
                } else {
                  this.$toast({
                    message: res.data.message,
                    duration: 500
                  });
                }
              }
            }
          );
        })
        .catch(() => {
          // on cancel
        });
    },
    getDatas: function() {
      var isUser = localStorage.getItem("BLHuser");
      var mallid = localStorage.getItem("mallid");
      this.$api.get(
        "user/address/list",
        { id_example: mallid, token_user: isUser },
        res => {
          if (res.data.code == "100") {
          } else {
            if (res.data.message == "token验证失败") {
              this.$dialog
                .confirm({
                  title: "提示 ",
                  message: "您还未登录是否去登录？"
                })
                .then(() => {
                  this.$router.push({ name: "NoteLogin" });
                })
                .catch(() => {});
            } else {
              this.$toast(res.data.message);
            }
          }
          if (res.data.data != null) {
            this.datas = res.data.data;
            this.checked = res.data.data.moren;
            this.length = res.data.data.length;
          }
        }
      );
    },
    morenPlay: function(id, index, moren) {
      var isUser = localStorage.getItem("BLHuser");
      var mallid = localStorage.getItem("mallid");
      if (moren != 1) {
        this.$api.post(
          "user/address/setdefault",
          { id_example: mallid, token_user: isUser, id_address: id },
          res => {
            if (res.data.code == "100") {
              $.each(this.datas, function(index, items) {
                items.moren = 0;
              });
              this.datas[index].moren = 1;
            } else {
              if (res.data.message == "token验证失败") {
                this.$dialog
                  .confirm({
                    title: "提示 ",
                    message: "您还未登录是否去登录？"
                  })
                  .then(() => {
                    this.$router.push({ name: "NoteLogin" });
                  })
                  .catch(() => {});
              } else {
                this.$toast({
                  message: res.data.message,
                  duration: 500
                });
              }
            }
          }
        );
      }
    }
  },
  mounted() {
    this.getDatas();
  }
};
</script>

<style lang="less" scoped>
.sitelist {
  .van-address-item__name {
    margin-bottom: 10px;
  }
  .van-checkbox__icon {
    color: #fff;
    border: 1px solid #999;
  }
  .sitebox {
    width: 100%;
  }
  .clearbtn {
    width: 65px;
    height: 100%;
  }
  .site-address {
    padding: 10px 0;
    border-bottom: 1px solid #f2f2f2;
  }
  .site-btnbox {
    padding-top: 5px;
    .iconfont {
      vertical-align: middle;
      font-size: 1.8rem;
      margin-right: 5px;
      margin-left: 10px;
    }
  }
  .addSiteBtn {
    border-right: 0;
    width: 100%;
    padding: 4px 20px;
    box-sizing: border-box;
    position: fixed;
    bottom: 0;
    left: 0;
    background: #fff;
    button {
      border-radius: 25px;
      border: none;
      width: 100%;
      float: left;
    }
  }
  .popupleft {
    width: 100%;
    height: 100%;
  }
  .van-card {
    margin: 15px 0;
  }
  .van-card,
  .van-cell-group,
  .van-cell {
    background-color: #fff;
  }
  .van-cell:not(:last-child)::after {
    border-bottom-width: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/mysite/mysite.vue